var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoobiVaultLogoDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 123,
    viewBox: "0 0 106 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 92.3934L15.8882 101.926V21.9438L0 30.8964V92.3934Z",
    fill: "#DA5026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5079 57.4584V15.0135L63.5408 42.7346V84.8896L20.5079 57.4584Z",
    fill: "#101018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9512 111.452V69.0068L63.5408 42.7346V84.8897L21.9512 111.452Z",
    fill: "#DA5026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.64 111.452L52.8581 123L106 92.3934V30.8964L53.148 0L29.1737 15.0135L69.0301 39.5592V87.1957L32.64 111.452Z",
    fill: "#101018"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 123,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoobiVaultLogoDesktop);
export default __webpack_public_path__ + "static/media/MoobiVaultLogo_desktop.f14e529d3d246e3bbda8af1820b9eb93.svg";
export { ForwardRef as ReactComponent };